import React from 'react';
import { Box, Tab, Tabs, Grid, useMediaQuery, useTheme } from '@mui/material';
import getTabStyle from './styles/style';
import Chip from '@mui/material/Chip';
import { COLOR_PRIMARY_2 } from 'src/colors';

const TabBar = ({
  tabList,
  currentTab,
  color,
  renderLabelCondition,
  actionButton,
  showActionButton,
  transparentBackground,
}: {
  tabList;
  currentTab;
  color;
  renderLabelCondition;
  actionButton;
  showActionButton?;
  transparentBackground?: boolean;
}) => {
  const renderLabel = renderLabelCondition();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(900));
  let styles = getTabStyle(color, transparentBackground ? transparentBackground : false);

  return (
    <Box sx={styles.root}>
      <Grid
        container
        direction="row"
        justifyContent={matches ? 'center' : 'space-between'}
        alignItems="flex-end"
        item
        xs={12}
      >
        <Tabs value={currentTab} sx={styles.tabs} variant="scrollable" scrollButtons={false}>
          {tabList.map(currentTab => (
            <Tab
              icon={currentTab.icon}
              label={
                <span>
                  {renderLabel ? currentTab.label : ''}
                  {(currentTab.label == 'Discovery' || currentTab.label == 'Compare') && (
                    <Chip
                      label="Global"
                      sx={{
                        color: `${COLOR_PRIMARY_2}`,
                        border: `1px solid ${COLOR_PRIMARY_2}`,
                        marginLeft: '2px',
                        marginTop: '2px',
                        fontSize: '12px',
                        height: '20px',
                      }}
                      variant="outlined"
                      size="small"
                    />
                  )}
                </span>
              }
              value={currentTab.value}
              iconPosition="start"
              sx={styles.tab}
              onClick={currentTab.onclick}
              wrapped
            />
          ))}
        </Tabs>
        {showActionButton && actionButton}
      </Grid>
    </Box>
  );
};

export default TabBar;
